




































import {
    Component,
    Prop,
    ChoiceQuestion,
    ComponentConfig,
    QuestionType,
    ComponentStyle,
    ComponentStyleDefinition,
    InjectComponent,
    Mixins, VueComponent, Vue
} from "@zoovu/runner-browser-api";

import {QuestionConfiguration} from "../configuration";
import QuestionBaseMixin from "./question-base.vue";

@Component({})
export default class ChoiceQuestionView extends Mixins(QuestionBaseMixin) {

    @Prop()
    question: ChoiceQuestion;

    @ComponentConfig(QuestionConfiguration)
    componentConfiguration: QuestionConfiguration;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @InjectComponent("RadioButtonAnswerView")
    radioButtonAnswerView: VueComponent;

    @InjectComponent("CheckboxAnswerView")
    checkboxAnswerView: VueComponent;

    @InjectComponent("QuestionHeadView")
    questionHeadView: VueComponent;

    get QuestionType(): typeof QuestionType {
        return QuestionType;
    }

    isFirstAnswer(index): boolean {
        return index === 0;
    }

    isLastAnswer(index): boolean {
        return index === this.question.answers.length - 1;
    }

    maxTextHeights = [];
    minAnswersPerRow = 1;
    answersPerRow = [];
    imageHeights = [];

    hasImage(answer): boolean {
        return answer.images != null && answer.images[0] != null;
    }

    getFirstVisibleAnswer(): Element {
      const answerElement = (this.$refs.answerElement as Vue[]).find(answerElement => answerElement?.$el?.getBoundingClientRect);
      return answerElement?.$el || null;
    }

    getAnswersPerRow(): ReadonlyArray<number> {
        const answer = this.getFirstVisibleAnswer();

        if (!answer) return [];

        let answerWidth = answer.getBoundingClientRect().width;

        let windowWidth = Math.max(window.innerWidth, answerWidth * this.minAnswersPerRow + 1);
        const zoovuWidth = this.$el.getBoundingClientRect().width;
        if (windowWidth > zoovuWidth) {
            windowWidth = zoovuWidth;
        }

        return this.question.answers.map((answer, index) => Math.trunc(((index + 1) * answerWidth) / windowWidth));
    }

    getTextHeight(index, property): string {
        if (!this.maxTextHeights) return 'auto';

        const heightBox = this.maxTextHeights[this.answersPerRow[index]];

        if (heightBox) return heightBox[property] + 'px'; else return 'auto';
    }

    clearAllHeights(): void {
        this.answersPerRow = this.getAnswersPerRow();
        this.maxTextHeights = [];
        this.imageHeights = [];
    }

    hasImageInRow(start, count): boolean {
        return this.question.answers.reduce((has, answer, index) => {
            if (index >= start && index <= start + count - 1) {
                return has || this.hasImage(answer);
            } else {
                return has || false;
            }
        }, false);
    }

    updateAnswerTextHeight(): void {
        this.maxTextHeights = (this.$refs.answerElement as Vue[]).reduce((maxTextHeights, {$children: [choiceAnswer]}, index) => {
            const answerTextElement = choiceAnswer?.$refs.answerTextElement as HTMLElement;
            if (!answerTextElement?.getBoundingClientRect) {
                return maxTextHeights;
            }

            const rectAnswerHeight = answerTextElement.getBoundingClientRect().height;

            const topKey = this.answersPerRow[index];

            if (maxTextHeights[topKey] === undefined) {
                maxTextHeights[topKey] = {
                    answerTextHeight: 0,
                };
            }

            if (maxTextHeights[topKey].answerTextHeight < rectAnswerHeight) {
                maxTextHeights[topKey].answerTextHeight = rectAnswerHeight;
            }

            return maxTextHeights;
        }, []);
    }

    getAnswersInTheSameRow(i): ReadonlyArray<number> {
        const row = this.answersPerRow[i];
        let first = null;

        const length = this.question.answers.reduce((len, answer, index) => {
            if (row == this.answersPerRow[index]) {
                if (first === null) {
                    first = index;
                }
                return ++len;
            } else {
                return len;
            }
        }, 0);

        return [first, length];
    }

    updateImageBox(): void {
        this.imageHeights = (this.$refs.answerElement as Vue[]).reduce((imageHeights, {$children: [choiceAnswer]}, index) => {

            if (!choiceAnswer || !choiceAnswer.$refs.imageBoxElement) {
                return imageHeights;
            }

            const topKey = this.answersPerRow[index];

            let answers = this.getAnswersInTheSameRow(index);
            imageHeights[topKey] = this.hasImageInRow(answers[0], answers[1]) ? "auto" : "0px";

            return imageHeights;
        }, []);
    }

    mounted(): void {
        // double requestAnimationFrame bug
        // https://stackoverflow.com/questions/44145740/how-does-double-requestanimationframe-work
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.clearAllHeights();
                this.updateAnswerTextHeight();
                this.updateImageBox();
            })
        })
    }

    beforeMount(): void {
        window.addEventListener("resize", this.resizeEventListener);
    }

    beforeDestroy(): void {
        window.removeEventListener("resize", this.resizeEventListener);
    }

    resizeEventListener = async () => {
        this.clearAllHeights();
        await this.$nextTick();
        this.updateAnswerTextHeight();
        this.updateImageBox();
    };
}
